import axios from "axios";

/* eslint-disable no-console */
const LoggingPlugin = {
    install(Vue) {
        // 1. add global method or property
        Vue.prototype.$debug = function (title, info) {
            if (process.env.NODE_ENV === "development") {
                if (title) console.log(title);
                if (info) console.log(info);
            }
        };
        Vue.prototype.$log = function (level, title, text) {
            console[level](`${level}: ${title} - ${text}`);
            axios
                .post(this.apiActions.loggingUrl, {
                    level: level,
                    title: title,
                    text: text,
                })
                .catch(() => {
                    console.error("Failed to contact logging endpoint");
                });
        };
    },
};

export default LoggingPlugin;
